/** Where the issue's location stands against its level's current map (PT-7117). */
export enum IssueLocationOnMap {
  /** No pin and no area. */
  notLocated = 'notLocated',
  onCurrentVersion = 'onCurrentVersion',
  /** On another version of the documentation the level shows. */
  onOtherVersion = 'onOtherVersion',
  /** On a documentation the level no longer shows. */
  onPreviousMap = 'onPreviousMap',
}

export function isLocatedOnOtherVersion(locationOnMap: IssueLocationOnMap): boolean {
  return locationOnMap === IssueLocationOnMap.onOtherVersion;
}

/** Located on another version or another map than the level's current one: the location may be confirmed on it. */
export function isLocatedOnOutdatedMap(locationOnMap: IssueLocationOnMap): boolean {
  return locationOnMap === IssueLocationOnMap.onOtherVersion || locationOnMap === IssueLocationOnMap.onPreviousMap;
}

export function isNotLocated(locationOnMap: IssueLocationOnMap): boolean {
  return locationOnMap === IssueLocationOnMap.notLocated;
}
